// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-manager {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  /* position: relative; */\n  \n}\n", ""]);
// Exports
module.exports = exports;
